// /costs API
//  - GET  /costs/                   -> get all cost calculations
//  - GET  /costs/total              -> get total cost
//  - GET  /costs/agent/:agent       -> get costs by agent

export class CostAPI {
  /** @param {import('../httpClient').HttpClient} http */
  constructor(http) {
    this.http = http;
  }

  /**
   * Get all cost calculations
   * @returns {Promise<{costs: Array, total_cost: number, count: number}>}
   */
  getAllCosts() {
    return this.http.get("/costs/");
  }

  /**
   * Get total cost across all agents
   * @returns {Promise<{total_cost: number}>}
   */
  getTotalCost() {
    return this.http.get("/costs/total");
  }

  /**
   * Get cost calculations filtered by agent name
   * @param {string} agentName - The agent name to filter by
   * @returns {Promise<{agent: string, costs: Array, total_cost: number, count: number}>}
   */
  getCostsByAgent(agentName) {
    return this.http.get(`/costs/agent/${encodeURIComponent(agentName)}`);
  }
}
